import { Configuration } from '@azure/msal-browser';



export interface MsalAngularConfiguration extends Configuration {
  loginHint?: string;
  domainHint?: string;
  tenant?: string;
  extraQueryParameters?: { [key: string]: string };
  protectedResourceScopeMap?: [string, string[]][] | Map<string, Array<string>>;
  useRedirect?: boolean;
}

export const DefaultProtectedResourceScopesMap: [string, string[]][] = [
  ['https://graph.microsoft.com', ['https://graph.microsoft.com/.default']], // Graph
  ['https://graph.windows.net', ['https://graph.windows.net/.default']], // old Graph
  ['/api/v1/', ['dcad865d-9257-4521-ad4d-bae3e137b345/.default']], // SPHome
];

